<template>
  <!-- ================= MOBIL ================= -->
  <div v-if="isMobile" class="mm-mob">
    <!-- Nivel 0: Mărci -->
    <template v-if="!mobMarca">
      <div class="mm-mob-head">Mărci</div>
      <div class="mm-list">
        <div v-if="!marci.length" class="mm-empty">Nicio marcă.</div>
        <div v-for="m in marci" :key="m.ID" class="mm-card" @click="openModele(m)">
          <span class="mm-card-nume">{{ m.Nume }}</span>
          <div class="mm-card-actiuni">
            <button class="mm-ic edit" title="Editează" @click.stop="editMarca(m)"><i class="dx-icon dx-icon-edit" /></button>
            <button class="mm-ic del" title="Șterge" @click.stop="delMarca(m)"><i class="dx-icon dx-icon-trash" /></button>
            <i class="dx-icon dx-icon-chevronright mm-chev" />
          </div>
        </div>
      </div>
      <button class="mm-fab" title="Adaugă marcă" @click="addMarca"><i class="dx-icon dx-icon-plus" /></button>
    </template>

    <!-- Nivel 1: Modele ale mărcii -->
    <template v-else>
      <div class="mm-mob-back" @click="mobMarca = null"><i class="dx-icon dx-icon-chevronleft" /><span>Mărci</span></div>
      <div class="mm-mob-head">Modele — {{ mobMarca.Nume }}</div>
      <div class="mm-list">
        <div v-if="!modele.length" class="mm-empty">Niciun model.</div>
        <div v-for="mo in modele" :key="mo.ID" class="mm-card" @click="editModel(mo)">
          <span class="mm-card-nume">{{ mo.Nume }}</span>
          <div class="mm-card-actiuni">
            <button class="mm-ic del" title="Șterge" @click.stop="delModel(mo)"><i class="dx-icon dx-icon-trash" /></button>
          </div>
        </div>
      </div>
      <button class="mm-fab" title="Adaugă model" @click="addModel"><i class="dx-icon dx-icon-plus" /></button>
    </template>

    <!-- Popup mobil (marcă / model) -->
    <DxPopupStd :visible="popupVisible" :show-title="true" :full-screen="true" height="auto"
      :close-on-outside-click="false" :show-close-button="true" @hidden="popupVisible = false">
      <template #title><div class="mm-title">{{ popupTitle }}</div></template>
      <DxFormStd ref="formRef" :form-data="formData" :col-count="1" label-location="top">
        <DxSimpleItem data-field="Nume" :label="{ text: 'Nume' }">
          <DxRequiredRuleStd message="Numele este obligatoriu" />
        </DxSimpleItem>
      </DxFormStd>
      <div class="mm-footer">
        <DxButton text="Salvează" type="default" icon="save" width="120" :disabled="isSaving" @click="onSave" />
        <DxButton text="Anulează" type="normal" styling-mode="outlined" width="120" @click="popupVisible = false" />
      </div>
    </DxPopupStd>
  </div>

  <!-- ================= DESKTOP ================= -->
  <div v-else class="mm-split">
    <!-- Stânga: Mărci -->
    <div class="mm-pane mm-left">
      <div class="mm-pane-title">Mărci</div>
      <DxDataGrid
        ref="marcaGrid"
        :data-source="dsMarca"
        key-expr="ID"
        height="100%"
        :show-borders="true"
        :show-column-lines="false"
        :show-row-lines="true"
        :row-alternation-enabled="true"
        :hover-state-enabled="true"
        @selection-changed="onMarcaSelected"
        @init-new-row="onInitMarca"
      >
        <DxSelection mode="single" />
        <DxFilterRow :visible="true" />
        <DxSearchPanel :visible="true" placeholder="Caută..." />
        <DxPaging :page-size="15" />
        <DxSorting mode="multiple" />
        <DxEditing :allow-adding="true" :allow-updating="true" :allow-deleting="true" mode="popup">
          <DxPopup :show-title="true" :width="400" height="auto" title-template="marcaTitle" :close-on-outside-click="false" />
          <DxForm :col-count="1" />
        </DxEditing>
        <template #marcaTitle><div class="mm-title">Marcă</div></template>
        <DxColumn data-field="ID" caption="ID" :width="70" :allow-editing="false" :visible="false" :form-item="{ visible: false }" />
        <DxColumn data-field="Nume" caption="Nume"><DxRequiredRule message="Numele este obligatoriu" /></DxColumn>
        <DxColumn data-field="Cod" caption="Cod" :width="90" :visible="false" :form-item="{ visible: false }" />
        <DxToolbar>
          <DxItem name="addRowButton" />
          <DxItem name="searchPanel" />
        </DxToolbar>
      </DxDataGrid>
    </div>

    <!-- Dreapta: Modele ale mărcii selectate -->
    <div class="mm-pane mm-right">
      <div class="mm-pane-title">
        Modele<span v-if="marcaNume"> — {{ marcaNume }}</span>
      </div>
      <DxDataGrid
        v-if="selectedMarcaId"
        ref="modelGrid"
        :data-source="dsModel"
        key-expr="ID"
        height="100%"
        :show-borders="true"
        :show-column-lines="false"
        :show-row-lines="true"
        :row-alternation-enabled="true"
        :hover-state-enabled="true"
        @init-new-row="onInitModel"
      >
        <DxFilterRow :visible="true" />
        <DxSearchPanel :visible="true" placeholder="Caută..." />
        <DxPaging :page-size="15" />
        <DxSorting mode="multiple" />
        <DxEditing :allow-adding="true" :allow-updating="true" :allow-deleting="true" mode="popup">
          <DxPopup :show-title="true" :width="400" height="auto" title-template="modelTitle" :close-on-outside-click="false" />
          <DxForm :col-count="1" />
        </DxEditing>
        <template #modelTitle><div class="mm-title">Model</div></template>
        <DxColumn data-field="ID" caption="ID" :width="70" :allow-editing="false" :visible="false" :form-item="{ visible: false }" />
        <DxColumn data-field="Nume" caption="Nume"><DxRequiredRule message="Numele este obligatoriu" /></DxColumn>
        <DxColumn data-field="Cod" caption="Cod" :width="90" :visible="false" :form-item="{ visible: false }" />
        <DxToolbar>
          <DxItem name="addRowButton" />
          <DxItem name="searchPanel" />
        </DxToolbar>
      </DxDataGrid>
      <div v-else class="mm-empty-desk">
        <i class="dx-icon dx-icon-car mm-empty-icon" />
        <span>Selectează o marcă pentru a-i vedea modelele.</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import DxDataGrid, {
  DxColumn, DxSelection, DxFilterRow, DxSearchPanel, DxPaging, DxSorting,
  DxEditing, DxPopup, DxForm, DxRequiredRule, DxToolbar, DxItem,
} from "devextreme-vue/data-grid";
import DxPopupStd from "devextreme-vue/popup";
import DxFormStd, { DxSimpleItem, DxRequiredRule as DxRequiredRuleStd } from "devextreme-vue/form";
import DxButton from "devextreme-vue/button";
import notify from "devextreme/ui/notify";
import { confirm } from "devextreme/ui/dialog";
import AppSettings from "@/settings/appSettings";

function store(entity: string): ODataStore {
  return new ODataStore({
    url: AppSettings.API_Url_ParcAutoOdata + entity,
    key: "ID",
    keyType: "Int32",
    version: 4,
    beforeSend: (e: any) => {
      e.headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("ERA_Jwt"),
      };
    },
  });
}

export default defineComponent({
  name: "MarciModele",
  components: {
    DxDataGrid, DxColumn, DxSelection, DxFilterRow, DxSearchPanel, DxPaging, DxSorting,
    DxEditing, DxPopup, DxForm, DxRequiredRule, DxToolbar, DxItem,
    DxPopupStd, DxFormStd, DxSimpleItem, DxRequiredRuleStd, DxButton,
  },
  data() {
    return {
      // desktop
      dsMarca: new DataSource({ store: store("PAM_Marca"), paginate: true, pageSize: 15 }),
      dsModel: null as any,
      selectedMarcaId: null as number | null,
      marcaNume: "" as string,
      // mobil
      isMobile: window.matchMedia("(max-width: 768px)").matches,
      storeMarca: store("PAM_Marca"),
      storeModel: store("PAM_Model"),
      marci: [] as any[],
      modele: [] as any[],
      mobMarca: null as any,
      popupVisible: false,
      popupEntity: "marca" as "marca" | "model",
      isEdit: false,
      isSaving: false,
      formData: {} as Record<string, any>,
    };
  },
  computed: {
    popupTitle(): string {
      const t = this.popupEntity === "marca" ? "marcă" : "model";
      return (this.isEdit ? "Editare " : "Adăugare ") + t;
    },
  },
  created() {
    if (this.isMobile) this.loadMarci();
  },
  methods: {
    // ---- desktop ----
    onMarcaSelected(e: any) {
      const row = e.selectedRowsData?.[0];
      if (!row) return;
      this.selectedMarcaId = row.ID;
      this.marcaNume = row.Nume;
      this.dsModel = new DataSource({ store: store("PAM_Model"), filter: ["MarcaID", "=", row.ID], paginate: true, pageSize: 15 });
    },
    onInitMarca(e: any) { delete e.data.ID; },
    onInitModel(e: any) { delete e.data.ID; e.data.MarcaID = this.selectedMarcaId; },

    // ---- mobil ----
    async loadMarci() {
      try { this.marci = Object.freeze((await this.storeMarca.load({})) as any[]) as any[]; }
      catch { this.marci = []; }
    },
    async openModele(m: any) {
      this.mobMarca = m;
      try {
        this.modele = Object.freeze((await this.storeModel.load({ filter: ["MarcaID", "=", m.ID] })) as any[]) as any[];
      } catch { this.modele = []; }
    },
    addMarca() { this.popupEntity = "marca"; this.isEdit = false; this.formData = {}; this.popupVisible = true; },
    editMarca(m: any) { this.popupEntity = "marca"; this.isEdit = true; this.formData = { ...m }; this.popupVisible = true; },
    addModel() { this.popupEntity = "model"; this.isEdit = false; this.formData = { MarcaID: this.mobMarca?.ID }; this.popupVisible = true; },
    editModel(mo: any) { this.popupEntity = "model"; this.isEdit = true; this.formData = { ...mo }; this.popupVisible = true; },
    async delMarca(m: any) {
      if (!(await confirm("Ștergeți această marcă?", "Confirmare"))) return;
      try { await this.storeMarca.remove(m.ID); notify("Marcă ștearsă.", "success", 1500); this.loadMarci(); }
      catch (e: any) { notify(e?.message || "Ștergere eșuată.", "error", 4000); }
    },
    async delModel(mo: any) {
      if (!(await confirm("Ștergeți acest model?", "Confirmare"))) return;
      try { await this.storeModel.remove(mo.ID); notify("Model șters.", "success", 1500); this.openModele(this.mobMarca); }
      catch (e: any) { notify(e?.message || "Ștergere eșuată.", "error", 4000); }
    },
    async onSave() {
      const form = (this.$refs.formRef as any)?.instance;
      const res = form?.validate();
      if (res && res.isValid === false) return;
      this.isSaving = true;
      const st = this.popupEntity === "marca" ? this.storeMarca : this.storeModel;
      try {
        const payload: Record<string, any> = { ...this.formData };
        if (this.isEdit) { const id = payload.ID; delete payload.ID; await st.update(id, payload); }
        else { delete payload.ID; await st.insert(payload); }
        notify("Salvat.", "success", 1500);
        this.popupVisible = false;
        if (this.popupEntity === "marca") this.loadMarci();
        else this.openModele(this.mobMarca);
      } catch (e: any) {
        notify(e?.message || "Salvare eșuată.", "error", 4000);
      } finally {
        this.isSaving = false;
      }
    },
  },
});
</script>

<style scoped>
.mm-split { display: flex; height: 100%; gap: 12px; }
.mm-pane { display: flex; flex-direction: column; min-width: 0; height: 100%; }
.mm-left { flex: 0 0 42%; border-right: 1px solid #e5e7eb; padding-right: 12px; }
.mm-right { flex: 1; }
.mm-pane-title { font-size: 13px; font-weight: 700; color: #334155; padding: 6px 2px 10px; }
.mm-empty-desk {
  flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center;
  gap: 10px; color: #94a3b8; font-size: 13px; padding: 16px;
}
.mm-empty-icon { font-size: 34px; color: #cbd5e1; }
.mm-title { background: linear-gradient(90deg, #ff2c21, #ff6a4a); color: #fff; font-weight: bold; font-size: 15px; padding: 10px 20px; width: 100%; }

/* ---- Mobil ---- */
.mm-mob { position: relative; height: 100%; display: flex; flex-direction: column; background: #f4f6fb; }
.mm-mob-head { flex-shrink: 0; font-size: 15px; font-weight: 700; color: #1e293b; padding: 12px 14px 6px; }
.mm-mob-back {
  flex-shrink: 0; display: flex; align-items: center; gap: 4px;
  padding: 12px 14px; background: #fff; border-bottom: 1px solid #e5e7eb;
  color: #2563eb; font-size: 15px; font-weight: 600; cursor: pointer;
}
.mm-mob-back .dx-icon { font-size: 20px; }
.mm-list { flex: 1; overflow-y: auto; padding: 8px 12px 90px; display: flex; flex-direction: column; gap: 10px; }
.mm-empty { text-align: center; color: #94a3b8; font-size: 14px; padding: 24px 12px; }
.mm-card {
  display: flex; align-items: center; justify-content: space-between; gap: 10px;
  background: #fff; border-radius: 14px; box-shadow: 0 3px 12px rgba(15, 23, 42, 0.06);
  padding: 14px 16px; cursor: pointer;
}
.mm-card-nume { font-size: 16px; font-weight: 700; color: #0f172a; }
.mm-card-actiuni { display: flex; align-items: center; gap: 6px; }
.mm-ic {
  width: 32px; height: 32px; display: flex; align-items: center; justify-content: center;
  border: none; border-radius: 50%; cursor: pointer;
}
.mm-ic.edit { background: #eff6ff; color: #2563eb; }
.mm-ic.del { background: #fef2f2; color: #ef4444; }
.mm-ic .dx-icon { font-size: 15px; }
.mm-chev { color: #cbd5e1; font-size: 18px; }
.mm-fab {
  position: fixed; right: 18px; bottom: 18px; z-index: 5;
  width: 52px; height: 52px; border-radius: 50%; border: none;
  background: linear-gradient(135deg, #ff2c21, #ff6a4a); color: #fff;
  box-shadow: 0 6px 18px rgba(255, 44, 33, 0.4);
  display: flex; align-items: center; justify-content: center;
}
.mm-fab .dx-icon { font-size: 24px; }
.mm-footer { display: flex; justify-content: flex-end; gap: 10px; padding-top: 16px; }
</style>
